import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import React from 'react';
import styled from '@emotion/styled';
import { colors, breakpoints, size } from "@argo/principles";
import { Link } from "@argo/ui-elements";
import { navbp } from '../../header/utils/constants';
import { GLOBALNAV_KBB_BASE_URL } from '../../mykbb/utils/constants';
var LinksBase = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: 0 ", "px ", "px ", "px;\n  column-count: 2;\n  column-width: 120px;\n  column-gap: ", "px;\n\n  @media (min-width: ", "px) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    justify-content: center;\n    column-count: 1;\n  }\n\n  @media (min-width: ", ") {\n    justify-content: center;\n  }\n\n  > a {\n    display: inline-block;\n    width: 100%;\n    padding: 12px 0;\n    margin: 0 0 ", "px 0;\n\n    @media (min-width: ", "px) {\n      width: auto;\n    }\n  }\n\n"])), colors.primary.white, size.md, size.md, size.md, size.sm, breakpoints.md, navbp.ipadLandscape, size.xs, breakpoints.md);
var SpanDivider = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: none;\n\n  @media (min-width: ", "px) {\n    display: block;\n    margin: ", "px ", "px ", "px;\n    padding-top: ", "px;\n  }\n"])), breakpoints.md, size.xs, size.sm, size.sm, size.micro);
var Links = function Links(_ref) {
  var links = _ref.links,
    triggerAnalytics = _ref.triggerAnalytics;
  return React.createElement(LinksBase, null, links && links.map(function (link, i) {
    return [React.createElement(Link, {
      key: i,
      "data-automation": "".concat(link.omnitureTag, "footer"),
      "data-partner": link.partnerLink,
      "data-tag-id": "footerLinks".concat(i),
      onClick: triggerAnalytics && triggerAnalytics({
        googleTag: link === null || link === void 0 ? void 0 : link.googleTag,
        pixallTag: link === null || link === void 0 ? void 0 : link.pixallTag
      }),
      rel: (link === null || link === void 0 ? void 0 : link.rel) || null,
      target: link.target,
      href: "".concat(GLOBALNAV_KBB_BASE_URL).concat(link.url),
      dangerouslySetInnerHTML: {
        __html: link.name
      },
      type: 'unstyled'
    }), i !== links.length - 1 && React.createElement(SpanDivider, {
      key: "a".concat(i)
    }, "|")];
  }));
};
Links.displayName = 'Links';
export default Links;